import { CustomFieldListItemProps } from "@/components/custom-field/list-item/custom-field-list-item.type.ts";
import useFormatter from "@/hooks/use-formatter.hook.ts";
import { LinkTo, ListItem, Stack, Text } from "@skailer-com/uikit";

function isValidUrl(value: string): boolean {
  try {
    new URL(value);
    return true;
  } catch {
    return false;
  }
}

export function CustomFieldUrlValue({
  url,
  label,
  className,
}: {
  url: string;
  label?: string | null;
  className?: string;
}) {
  const { truncate } = useFormatter();
  const text = label || truncate(url, 40);

  if (!isValidUrl(url)) {
    return <Text className={className}>{text}</Text>;
  }

  return (
    <Stack direction={"horizontal"}>
      <LinkTo
        to={url}
        target={"_blank"}
        rel="noopener noreferrer"
        title={url}
        variant={"secondary"}
        className={className}
      >
        {text}
      </LinkTo>
    </Stack>
  );
}

export function CustomFieldListItemUrl({ field, fieldValue, label }: CustomFieldListItemProps) {
  const url = fieldValue?.value_text;

  return (
    <ListItem
      preTitle={label ?? field.title}
      titleSlot={
        url ? (
          <CustomFieldUrlValue
            url={url}
            label={fieldValue?.value_label}
            className={"truncate text-title"}
          />
        ) : (
          <>{"-"}</>
        )
      }
    />
  );
}
